module.exports = __webpack_public_path__ + "03e518dd94e6fed8d39f0d934cfa63b0.png";